import React, { Component } from "react";
import { Form, Input, Select, Radio } from "antd";
import { connect } from "react-redux";
import { withRouter, RouteComponentProps, match } from "react-router-dom";
// import * as _ from 'lodash';

import style from "./list.module.sass";
import {
  addFroms,
  updateForms
} from "../../../../stateManager/store/forms/action";
import { Http } from "../../../../helpers/axois";
import { makeFormDupliacte } from "../../../../helpers/RxServices";
import { AppState } from "../../../../stateManager/store";
import { pushToast } from '../../../../stateManager/store/toast/actions'
import { logger } from "../../../../constant/winston";
import { addStyleUrl, isCoreV3Form } from "../../../../stateManager/store/formCreation_v2/actions"
import { setGuideVisible, setStepIndex, setOnboardingAppDetails } from "../../../../stateManager/store/onboarding/action"
import { fetchAllStaticAssetsByFiletype } from "../../../../stateManager/store/static-assets/action"
import { addAssetInstancesToForm } from "../../forms/formBuilder/helpers";
import { decodeBase64, encodeBase64 } from "../../../../helpers/commonFunction";
import { updateOnboarding } from "../../../../helpers/onboardingHelper";


const { Option } = Select;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 }
  }
};

interface State {
  formName?: string;
  displayName?: string
  formNameErr?: string
  displayNameErr?: string
  themeList?: any[]
  theme?: string
  themeError?: string
  isV2?: boolean
  styleUrl?: string;
  coreVersion?:string;
}
interface CssAsset {
  [key: string]: {
    id: string;
    filename: string;
    url: string;
}
}


interface Props {
  onSubmit?: (submit: () => void) => void;
  appId?: any;
  getForms?: () => void;
  addFroms?: (data: any) => void;
  editInitialData?: any;
  editable?: boolean;
  updateForms?: (data: any) => void;
  getSavedForm?: (SavedForm: any) => void
  match: match<any>
  appVersion?: { currentVersion: boolean, versionId: string }
  duplicate?: boolean;
  pushToast?: (data: any) => void;
  currentOrgId?: any;
  // adding passed version id from form creation page since version gets wrongly set while navigating from that page alone
  versionId?: string;
  currentBranch?: any;
  addStyleUrl?: any;
  fetchAllStaticAssetsByFiletype?:any;
  cssAssets?: CssAsset
  selectedApp?: any;
  loggedInUserId?: any;
  json?: any;
  isCoreV3Form?: any;
  setStepIndex?: any;
  setGuideVisible?: any;
  onboardingInfo?: any;
  userName?: string | any;
  setOnboardingAppDetails?: any;
}
class AppForm extends Component<RouteComponentProps & Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      formName:
        this.props.editInitialData && this.props.editInitialData.formName
          ? this.props.editInitialData.formName
          : "",
      displayName: this.props.editInitialData && this.props.editInitialData.displayName
        ? this.props.editInitialData.displayName
        : "",
      formNameErr: "",
      displayNameErr: "",
      themeError: '',
      theme: this.props.editInitialData && this.props.editInitialData.themeId
        ? this.props.editInitialData.themeId
        : "",
      isV2: this.props.onboardingInfo.guideVisible ? true : this.props.editInitialData
        ? this.props.editInitialData.isV2
        : false,
      coreVersion:  this.props.editInitialData?.isV2 ? this.props.editInitialData?.coreVersion.toUpperCase(): "V1",
      styleUrl:
        this.props.editInitialData && this.props.editInitialData.styleUrl
          ? this.props.editInitialData.styleUrl
          : "",
    };
    this.props.onSubmit!(this.onSubmit);
  }

  componentDidMount() {
    this.getThemes();
  }

  getThemes = () => {
    Http.get(`org/${this.props.currentOrgId}/themes`).subscribe((res: any) => {
      this.setState({ themeList: res })
    }, (error) => {
      logger.error("get theme error ===> ", error);
    })
  }

  // TO save form json while updating the form custom css
  saveForm = (isCommit: boolean) => {
    const currentBranchId =
      this.props.currentBranch &&
      this.props.currentBranch[this.props.appId] &&
      this.props.currentBranch[this.props.appId].branchId;
    Http.get(`/apps/${this.props.appId}/forms/${this.props.editInitialData.formId}?versionId=${this.props.appVersion && this.props.appVersion.versionId}&branchId=${currentBranchId}`).subscribe((res: any) => {
      if (res.length > 0) {
        const response = res[0]
        if (response.resourceLock.userId === this.props.loggedInUserId) {
          const base64Data = response && response.source;
          const formData = base64Data ? JSON.parse(decodeBase64(base64Data)) : "";
          addAssetInstancesToForm(formData)
          const selectedApp = this.props.selectedApp && this.props.selectedApp || {};
          const appid = this.props.appId && this.props.appId || "";
          const globalCss = selectedApp.find((el: any) => el.appId === appid) ?? '';
          const updatedFormData = {
            ...formData,
            styleUrl: {
              customCssUrl: this.state.styleUrl,
              globalCssUrl: globalCss.globalcss
            },
          };
          const data = {
            source: encodeBase64(JSON.stringify(updatedFormData)),
            appId: this.props.appId,
            version: this.props.appVersion && this.props.appVersion.versionId,
            branchId: currentBranchId,
            styleUrl: this.state.styleUrl
          }
          Http.put(`/forms/${this.props.editInitialData.formId}?isCommit=${isCommit}`, data).subscribe((formRes) => {
            logger.info("Form saved successfully")
          }, (err) => {
            this.props.pushToast && this.props.pushToast(
              { type: 'error', message: 'Error while saving form' }
            )
          }
          )
        }
      }
    })
  }

  onSubmit = () => {
    const currentBranchId = this.props.currentBranch && this.props.currentBranch[this.props.appId] && this.props.currentBranch[this.props.appId].branchId
    let shouldModalClose = true;
    if (this.state.formName && this.state.theme && this.state.displayName) {
      let { editable, editInitialData, duplicate } = this.props;
      if (duplicate) {
        makeFormDupliacte.sendMessage({ from: 'duplicate', formName: this.state.formName, theme: this.state.theme, branchId: currentBranchId, displayName: this.state.displayName })
      } else {
        if (!editable) {
          this.saveForms();
        } else if (editInitialData) {
          this.updateForms(editInitialData.formId)
        }
      }
    } else {
      const error: any = {}
      if (!this.state.theme) error['themeError'] = 'required'
      if (!this.state.formName) error['formNameErr'] = 'required'
      if (!this.state.displayName) error['displayNameErr'] = 'required'
      this.setState(error)
      shouldModalClose = false
    }
    return shouldModalClose
  };

  checkout = (props: any) => {
    const {app_id, version_id, form_id} = props;
    Http.post(`forms/${form_id}/checkout`, {
      appId: app_id,
      versionId: version_id
    }).subscribe(() => {
    }, (err) => {
      this.props.pushToast && this.props.pushToast(
        {type: 'error', message: (err && err.message) ? err.message : "Form checkout failed"}
      )
    })
  }

  saveForms() {
    const currentBranchId = this.props.currentBranch && this.props.currentBranch[this.props.appId] && this.props.currentBranch[this.props.appId].branchId
    let data:any = {
      name: this.state.formName,
      displayName: this.state.displayName,
      appId: this.props.appId,
      themeId: this.state.theme,
      version: this.props.appVersion && this.props.appVersion.versionId,
      branchId: currentBranchId,
      isV2: this.state.isV2,
      styleUrl: this.state.styleUrl ? this.state.styleUrl : "",
      coreVersion: 'v3'
    }

    if(this.state.isV2){
      data = {
        ...data,
        styleUrl: this.state.styleUrl ? this.state.styleUrl : ""
      }
    }
    const { onboardingInfo } = this.props;
    const stepIndex = this.props.onboardingInfo.info.stepIndex;
    if (onboardingInfo.guideVisible) {
      this.props.setStepIndex(stepIndex + 1)
    }
    Http.post('forms', data).subscribe((formRes:any) => {
      if (onboardingInfo.guideVisible) {
        const form_id = formRes.length && formRes[0].form_id;
        const payload = {
          ...this.props.onboardingInfo.info,
          stepIndex: stepIndex + 1,
          formId: this.props.onboardingInfo.info.formId ? [...this.props.onboardingInfo.info.formId, form_id]:[form_id],
          isV2: formRes[0].is_v2
        }
        this.props.setOnboardingAppDetails(payload)
      }
      const response = formRes && formRes.length > 0 && formRes[0];
      if(this.state.isV2){
        const data = {
          customCssUrl: this.state.styleUrl
        }
        this.props.addStyleUrl(data)
        if (response.core_version === "v3") {
          this.props.isCoreV3Form(true)
        } else {
          this.props.isCoreV3Form(false)
        }
      }
      if (response && response?.app_id && response?.version_id && response?.form_id) {
        const {app_id, version_id, form_id} = response;
        this.checkout({app_id , version_id, form_id})
      }
      this.props.pushToast && this.props.pushToast(
        { type: 'success', message: 'Form saved successfully' }
      )
      this.props.getSavedForm && this.props.getSavedForm(formRes);
      this.props.getForms && this.props.getForms();
    }, (err) => {
      this.props.pushToast && this.props.pushToast(
        { type: 'error', message: (err && err.message) ? err.message : "Form save failed" }
      )
    })

  }

  updateForms(formId?: string) {
    const currentBranchId = this.props.currentBranch && this.props.currentBranch[this.props.appId] && this.props.currentBranch[this.props.appId].branchId
    let data: any = {
      name: this.state.formName,
      displayName: this.state.displayName,
      appId: this.props.appId,
      themeId: this.state.theme,
      version: this.props.versionId ? this.props.versionId : this.props.appVersion && this.props.appVersion.versionId,
      branchId: currentBranchId,
      isV2: this.state.isV2
    }
    if (this.state.isV2) {
      data = {
        ...data,
        styleUrl: this.state.styleUrl
      }
    }

    Http.put(`/forms/${formId}`, data).subscribe((formRes) => {
      this.props.pushToast && this.props.pushToast(
        { type: 'success', message: 'Form updated successfully' }
      )
      if (this.state.isV2) {
        this.saveForm(false)
      }
      this.props.getForms && this.props.getForms();
    }, (err) => {
      this.props.pushToast && this.props.pushToast(
        { type: 'error', message: (err && err.message) ? err.message : 'Form updation failed' }
      )
    })
  }

  onChangeBuilderType=(e:any)=>{
      var isV2 = true;
      if (e.target.value == "V1") {
        isV2 = false;
      }
    this.setState({ isV2,coreVersion:e.target.value });
  }

  render() {
    let { editInitialData } = this.props;
    let { formNameErr, themeError, displayNameErr } = this.state;
    const { cssAssets } = this.props;
    const cssAssetOptions = Object.values(cssAssets as CssAsset).map((asset: any) => {
      if(asset.url){
        return (
          <Option key={asset.id} value={asset.url || ""}>
            {asset.filename}
          </Option>
        );
      }
    });
    
    return (
      <div>
        <Form {...formItemLayout} className={style.app + ' override-content'}>
          <Form.Item
            className="form_creation_displayname"
            validateStatus={displayNameErr && "error"}
            help={displayNameErr}
            label={<span className={style.labelName}>Display Name</span>}>
            <Input
              data-test-id="display_name"
              defaultValue={editInitialData && editInitialData.displayName}
              value={this.state.displayName}
              onKeyDown={
                (e: React.KeyboardEvent) => {
                   if(this.props.onboardingInfo.guideVisible && e.key === 'Tab') {
                    e.preventDefault()
                  }
              }} 
              onChange={e => { 
                const re = /^[A-Za-z_][A-Za-z0-9,_/;'"!&@%$-\s]*$/;                                ;
              if (e.target.value === '' || re.test(e.target.value)) {
                let val =  e.target.value.replace(/[^a-zA-Z0-9_ ]/g, "") 
                let value =  val.replace(/ /g,"_") 
                this.setState({ displayName: e.target.value, formName:editInitialData? this.state.formName: value, displayNameErr: "" })}}}
            />
          </Form.Item>
          <Form.Item
            validateStatus={formNameErr && "error"}
            help={formNameErr}
            label={<span className={style.labelName}>Name(identifier)</span>}>
            <Input
              data-test-id="form_name"
              disabled={editInitialData}
              defaultValue={editInitialData && editInitialData.formName}
              value={this.state.formName}
              onKeyDown={
                (e: React.KeyboardEvent) => {
                   if(this.props.onboardingInfo.guideVisible && e.key === 'Tab') {
                    e.preventDefault()
                  }
              }} 
              onChange={e => {
                const re = /^[A-Za-z_][A-Za-z0-9_]*$/;
                                if (e.target.value === '' || re.test(e.target.value)) {
                this.setState({ formName: e.target.value.trim().replace(/ /g, "_"), formNameErr: "" })}}}
            />
          </Form.Item>
          <Form.Item className="form_creation_type" label={<span className={style.labelName} >Builder Type</span>}>
            <Radio.Group
              disabled={this.props.editable}
              data-test-id="radio_builder_type"
              value={this.state.coreVersion}
              onChange={this.onChangeBuilderType}
            >
              <Radio 
                data-test-id="legacy" 
                value="V1"
                disabled={this.props.onboardingInfo.guideVisible}
                onKeyDown={
                  (e: React.KeyboardEvent) => {
                     if(this.props.onboardingInfo.guideVisible && e.key === 'Tab') { 
                      e.preventDefault()
                    }
                }} 
              >
                <span>V1</span>
              </Radio>
              {this.props.editable && <Radio 
                data-test-id="new"
                value="V2"
                onKeyDown={
                  (e: React.KeyboardEvent) => {
                     if(this.props.onboardingInfo.guideVisible && e.key === 'Tab') {
                      e.preventDefault()
                    }
                }} 
              >
                <span>V2</span>
              </Radio>}
              <Radio
                data-test-id="new"
                value="V3"
                onKeyDown={
                  (e: React.KeyboardEvent) => {
                    if (this.props.onboardingInfo.guideVisible && e.key === 'Tab') {
                      e.preventDefault()
                    }
                  }}
              >
                <span>V3</span>
              </Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            validateStatus={themeError && "error"}
            help={themeError}
            className="form_creation_theme"
            label={<span className={style.labelName}>Theme</span>}>
            <Select style={{ width: '100%' }}
              data-test-id="form_theme"
              dropdownClassName="form_creation_dropdown"
              defaultValue={editInitialData && editInitialData.themeId}
              onChange={(e: any) => this.setState({ theme: e, themeError: "" })}>
              {this.state.themeList &&
                this.state.themeList.map((d, index) =>
                (<Option data-test-id={`theme_${d.theme_name}`} key={index} value={d.theme_id}>
                  {d.theme_name} <small>({(d.is_system) ? 'system' : 'custom'})</small>
                </Option>)
                )}
            </Select>
          </Form.Item>
          {this.state.isV2 &&
            <Form.Item label={<span className={style.labelName}>Custom css</span>}>
              <Select
                data-test-id="form_css"
                style={{ width: "100%" }}
                defaultValue={editInitialData && editInitialData.styleUrl}
                onChange={(value) => {
               this.setState({ styleUrl: value });
             }}
           >
                <Option key="empty" value="empty">
                  Custom (empty)
                </Option>
             {cssAssetOptions}
           </Select>
         </Form.Item>
          }
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state: AppState, props: Props) => {
  const params: any = props.match.params;
  return {
    appId: state.apps.selectedApp.id,
    appVersion: state.apps.appVersion[params['appId']],
    currentOrgId: state.org.selectedOrg!.id,
    currentBranch: state.apps.appBranch,
    selectedApp: state.apps.appsList,
    loggedInUserId: state.user.data.user.id,
    cssAssets: state.staticAssets.css,
    onboardingInfo: state.onboarding,
    userName: state.user.data.user.userName
  }
}

export default withRouter(connect(
  mapStateToProps,
  { addFroms, updateForms, pushToast, addStyleUrl, fetchAllStaticAssetsByFiletype, isCoreV3Form, setStepIndex, setGuideVisible, setOnboardingAppDetails }
)(AppForm));
